import React from 'react';

import { ContainerStyled } from './style';
import Dropdown from 'react-bootstrap/Dropdown';

interface Props {
  label: string;
  items: {
    id: string;
    label: string;
  }[];
  onItemClicked: (id: string) => void;
  color?: string;
  className?: string;
  height?: string;
  lineHeight?: string;
  fontSize?: string;
  onBlur?: any;
}
const DropdownSimple = (props: Props) => {
  return (
    <ContainerStyled
      color={props.color}
      height={props.height}
      lineHeight={props.lineHeight}
      fontSize={props.fontSize}
      className={props.className || ''}
    >
      <Dropdown className="dropdown-simple" drop="down" onBlur={props.onBlur}>
        <Dropdown.Toggle>{props.label}</Dropdown.Toggle>
        <Dropdown.Menu>
          {props.items.map((item) => (
            <Dropdown.Item
              key={item.id}
              as="button"
              type="button"
              onClick={() => props.onItemClicked(item.id)}
            >
              {item.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </ContainerStyled>
  );
};

export default DropdownSimple;
